import { useBenchmarkTakeoverStore } from "src/stores/benchmarkTakeoverStore";
import { annotationHasPosition, renderedProseText, resolveSourceAnnotation } from "./comparisonProse";

// An old draft or unsupported changing markup can leave a tag without a safe
// position. Preserve it for review and let the writer remove/reselect it;
// never silently move that feedback onto another occurrence of the words.
export default function AnnotationIssues({ sample = null }) {
  const annotations = useBenchmarkTakeoverStore((state) => state.annotations);
  const samples = useBenchmarkTakeoverStore((state) => state.samples);
  const remove = useBenchmarkTakeoverStore((state) => state.removeAnnotation);
  const text = { A: renderedProseText(samples.A.text), B: renderedProseText(samples.B.text) };
  const issues = annotations.map((annotation, index) => ({ annotation: resolveSourceAnnotation(samples[annotation.sample].text, annotation), index }))
    .filter(({ annotation }) => (!sample || annotation.sample === sample) && !annotationHasPosition(text[annotation.sample], annotation));
  if (!issues.length) return null;
  return <div className="gate" role="alert">
    <p>These tags will be saved as quoted feedback without passage positions. You can remove a tag and select the passage again to retag it.</p>
    {issues.map(({ annotation, index }) => <div key={index}>
      <p>Option {annotation.sample}: “{annotation.text}” — {annotation.custom || annotation.tag}</p>
      <button type="button" onClick={() => remove(index)}>Remove this tag</button>
    </div>)}
  </div>;
}
